import { JsonObject, JsonProperty } from 'json2typescript';
import { ApiResultsResponse } from '../../api/responses/api-results-response.model';
import { NewsPredefined } from '../news-predefined.model';

@JsonObject('NewsPredefinedResultsResponse')
export class NewsPredefinedResultsResponse extends ApiResultsResponse<NewsPredefined> {

  @JsonProperty('results', [NewsPredefined])
  override results: NewsPredefined[] = [];

  @JsonProperty('results_total', Number)
  resultsTotal: number = 0;
}
